<div class="pt-details">
  <div class="pt-details__card">
    <h4>Policy information</h4>
    <div class="pt-details__rows">
      <div class="pt-details__row">
        <span class="pt-details__label">Policy holder</span>
        <span class="pt-details__value">{{ policy.holderName }}</span>
      </div>
      <div class="pt-details__row">
        <span class="pt-details__label">Insured address</span>
        <span class="pt-details__value">{{ insuredAddress }}</span>
      </div>
      <div class="pt-details__row">
        <span class="pt-details__label">Effective date</span>
        <span class="pt-details__value">{{ effectiveDate | date : "MMM d, y" }}</span>
      </div>
      <div class="pt-details__row">
        <span class="pt-details__label">Expiration date</span>
        <span class="pt-details__value">{{ expirationDate | date : "MMM d, y" }}</span>
      </div>
    </div>
  </div>

  <div class="pt-details__card">
    <h4>Coverage &amp; additional interest</h4>
    <div class="pt-coverages">
      <div class="pt-coverage" *ngFor="let coverage of coverages">
        <ng-container [ngSwitch]="coverageKind(coverage)">
          <svg *ngSwitchCase="'contents'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#50327d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M19 8v3a5.5 5.5 0 0 1 -5.5 5.5h-3a5.5 5.5 0 0 1 -5.5 -5.5v-3"></path>
            <path d="M12 4v12"></path>
            <path d="M5 8h14"></path>
            <path d="M12 16v4"></path>
          </svg>
          <svg *ngSwitchCase="'liability'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#50327d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"></path>
            <path d="M6 9l4 4"></path>
            <path d="M13 10l-4 -4"></path>
            <path d="M3 21h7"></path>
            <path d="M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z"></path>
          </svg>
          <svg *ngSwitchDefault width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#50327d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"></path>
          </svg>
        </ng-container>
        <span class="pt-coverage__label">{{ coverageTitle(coverage) }}</span>
        <span class="pt-coverage__amount">{{ coverageAmount(coverage) | currency : "USD" : "symbol" : "1.0-0" }}</span>
      </div>
    </div>

    <div class="pt-interest" *ngFor="let address of additionalInterestAddresses">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#62636c" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
        <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
      </svg>
      <div class="pt-interest__text">
        <span class="pt-interest__label">Additional interest</span>
        <span class="pt-interest__value">{{ address }}</span>
      </div>
    </div>
  </div>
</div>
